import {getHeaders, postHeaders} from './headers';

export const getRequestInit: RequestInit = {
  method: 'GET',
  headers: getHeaders,
  credentials: 'omit',
  mode: 'cors',
};

export const postRequestInit: RequestInit = {
  method: 'POST',
  headers: postHeaders,
  credentials: 'omit',
  mode: 'cors',
};

export const postFileRequestInit: RequestInit = {
  method: 'POST',
  credentials: 'omit',
  mode: 'cors',
};
